import { captureException } from '../logging/logger';

export default function initConsentPreferenceButtons(): void {
    document.querySelectorAll<HTMLButtonElement>( '[data-action="open-cookie-preferences"]' ).forEach( ( btn: HTMLButtonElement ) => {
        btn.addEventListener( 'click', ( event: Event ) => {
            if ( !window.revisitCkyConsent ) {
                captureException( 'cannot launch consent preferences as js is missing' );
                return;
            }
            window.revisitCkyConsent();
        } );
    } );
}

export function isConsentBannerVisible(): boolean {
    const banner = document.querySelector<HTMLElement>( '.cky-consent-container' );

    if ( !banner || banner.classList.contains( 'cky-hide' ) ) {
        return false;
    }

    return true;
}

export function isContentPreferencesVisible(): boolean {
    const popup = document.querySelector<HTMLElement>( '.cky-modal.cky-modal-open #ckyPreferenceCenter' );

    if ( !popup ) {
        return false;
    }

    return true;
}
